import ApiClient from './ApiClient';

class AccessLevelsAPI extends ApiClient {
  constructor() {
    super('access_levels', { accountScoped: true });
  }

  getCapabilities() {
    return this.axios.get(`${this.url}/capabilities`);
  }
}

export default new AccessLevelsAPI();
